import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const DEFAULT_OG_IMAGE = 'https://doorguard.app/og-default.jpg';
const SITE = 'https://doorguard.app';

/**
 * Per-page SEO + OG + canonical tags.
 * Use on every page: <SEO title="..." description="..." />
 */
const SEO = ({ title, description, image, type = 'website' }) => {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  const finalTitle = title || 'DojoDash | Find a Professional Coach Near You';
  const finalDesc = description || 'Book private sessions in BJJ, self-defense, and personal training. The coach comes to you.';
  const finalImg = image || DEFAULT_OG_IMAGE;
  return (
    <Helmet prioritizeSeoTags>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDesc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDesc} />
      <meta property="og:image" content={finalImg} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDesc} />
      <meta name="twitter:image" content={finalImg} />
    </Helmet>
  );
};

export default SEO;
